module.exports = __webpack_public_path__ + "5c54728d457fc94491bdd1046a568e32.png";